<lms-breadcrumb *ngIf="group; else noGroupName" [label]="group.name"></lms-breadcrumb>
<ng-template #noGroupName>
  <lms-breadcrumb [label]="'mars.create'"></lms-breadcrumb>
  <lms-mars-group-data [group]="group" (save)="onGroupDataSaved($event)">
    <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="onDelete()" form-actions-before>
    </gl-button>
  </lms-mars-group-data>
</ng-template>

<mat-tab-group
  class="tab-group"
  #tabGroup
  *ngIf="group"
  animationDuration="0ms"
  disableRipple="true"
  (selectedTabChange)="setTab($event)"
>
  <mat-tab label="data">
    <ng-template mat-tab-label>{{ 'groups.tabs.data' | translate }}</ng-template>
    <ng-template matTabContent>
      <lms-mars-group-data [group]="group" (save)="onGroupDataSaved($event)"></lms-mars-group-data>
    </ng-template>
  </mat-tab>
  <mat-tab label="config">
    <ng-template mat-tab-label>{{ 'groups.tabs.config' | translate }}</ng-template>
    <ng-template matTabContent>
      <lms-mars-group-config [group]="group" (save)="onUpdate($event)"></lms-mars-group-config>
    </ng-template>
  </mat-tab>
  <mat-tab label="enrollment">
    <ng-template mat-tab-label>{{ 'groups.tabs.enrollment' | translate }}</ng-template>
    <ng-template matTabContent>
      <lms-mars-group-license [group]="group" [options]="{ filters: filters }"></lms-mars-group-license>
    </ng-template>
  </mat-tab>
  <mat-tab label="activity">
    <ng-template mat-tab-label>{{ 'nouns.activityReport' | translate }}</ng-template>
    <ng-template matTabContent>
      <lms-mars-group-activity [group]="group"></lms-mars-group-activity>
    </ng-template>
  </mat-tab>
  <mat-tab label="notifications">
    <ng-template mat-tab-label>
      {{ 'mars.tabs.notifications' | translate }}
    </ng-template>
    <ng-template matTabContent>
      <lms-mars-group-notification [group]="group"></lms-mars-group-notification>
    </ng-template>
  </mat-tab>
  <mat-tab label="surveys">
    <ng-template mat-tab-label>{{ 'groups.tabs.surveys' | translate }}</ng-template>
    <ng-template matTabContent>
      <lms-mars-group-surveys [group]="group"></lms-mars-group-surveys>
    </ng-template>
  </mat-tab>
  <mat-tab label="tutorization">
    <ng-template mat-tab-label>{{ 'groups.tabs.tutorization' | translate }}</ng-template>
    <ng-template matTabContent>
      <lms-mars-group-tutorization [group]="group"></lms-mars-group-tutorization>
    </ng-template>
  </mat-tab>
</mat-tab-group>

<div *ngIf="group" class="gl-context-menu__position">
  <lms-button-actions *lmsProfileGuard="'mars.delete'">
    <div class="gl-context-menu__options">
      <span class="gl-context-menu__options--item alert" (click)="deleteGroup()">{{
        'actions.delete' | translate
      }}</span>
    </div>
  </lms-button-actions>
</div>
